import {
  IconAccount,
  IconCreditCard,
  IconDescription,
  IconEvent,
  IconFileSignature,
  IconLocalOffer,
  IconPaid,
  IconQuestionAnswer,
  IconSearchStrong,
  IconVerifiedUser,
  Logo,
} from '../../components';
import defaultConfig from '../../config/configDefault';

export const help = [
  {
    titleKey: 'crion-basics',
    subsections: [
      {
        icon: Logo,
        iconProps: { format: 'mobile' },
        subtitleKey: 'about-crion',
        links: [
          {
            params: { tab: 'about-crion', subtab: 'getting-started' },
            textKey: 'getting-started',
          },
          {
            params: { tab: 'about-crion', subtab: 'how-crion-works' },
            textKey: 'how-crion-works',
          },
          {
            params: { tab: 'about-crion', subtab: 'our-mission' },
            textKey: 'our-mission',
          },
          {
            params: { tab: 'about-crion', subtab: 'our-community' },
            textKey: 'our-community',
          },
          { params: { tab: 'about-crion', subtab: 'the-activity' }, textKey: 'the-activity' },
          {
            params: { tab: 'about-crion', subtab: 'traveler-or-provider' },
            textKey: 'traveler-or-provider',
          },
          { params: { tab: 'about-crion', subtab: 'partners' }, textKey: 'partners' },
          { params: { tab: 'about-crion', subtab: 'contact' }, textKey: 'contact' },
          {
            href: `${defaultConfig.siteLinkedinPage}jobs`,
            parentTextKey: 'General',
            textKey: 'jobOpenings',
          },
        ],
      },
      {
        icon: IconAccount,
        subtitleKey: 'your-account',
        links: [
          {
            params: { tab: 'your-account', subtab: 'creating-your-account' },
            textKey: 'creating-your-account',
          },
          {
            params: { tab: 'your-account', subtab: 'completing-your-profile' },
            textKey: 'completing-your-profile',
          },
          {
            params: { tab: 'your-account', subtab: 'managing-your-account' },
            textKey: 'managing-your-account',
          },
          {
            params: { tab: 'your-account', subtab: 'id-and-verification' },
            textKey: 'id-and-verification',
          },
          {
            params: { tab: 'your-account', subtab: 'account-security' },
            textKey: 'account-security',
          },
          { params: { tab: 'your-account', subtab: 'reviews' }, textKey: 'reviews' },
        ],
      },
      {
        icon: IconVerifiedUser,
        subtitleKey: 'safety',
        links: [
          {
            params: { tab: 'safety', subtab: 'safety-concerns' },
            textKey: 'safety-concerns',
          },
          {
            params: { tab: 'safety', subtab: 'safety-tips-for-travelers' },
            textKey: 'safety-tips-for-travelers',
          },
          {
            params: { tab: 'safety', subtab: 'safety-tips-for-providers' },
            textKey: 'safety-tips-for-providers',
          },
          { params: { tab: 'safety', subtab: 'restrictions' }, textKey: 'restrictions' },
          {
            params: { tab: 'safety', subtab: 'professionals-and-certifications' },
            textKey: 'professionals-and-certifications',
          },
          // {
          //   params: { tab: 'safety', subtab: 'sos-coverage-and-incidents' },
          //   textKey: 'sos-coverage-and-incidents',
          // },
        ],
      },
      {
        icon: IconFileSignature,
        subtitleKey: 'terms-and-policies',
        links: [
          {
            params: { tab: 'terms-and-policies', subtab: 'terms-and-conditions' },
            textKey: 'terms-and-conditions',
          },
          {
            params: { tab: 'terms-and-policies', subtab: 'cookie-policy' },
            textKey: 'cookie-policy',
          },
          {
            params: { tab: 'terms-and-policies', subtab: 'review-policy' },
            textKey: 'review-policy',
          },
          {
            params: { tab: 'terms-and-policies', subtab: 'privacy-policy' },
            textKey: 'privacy-policy',
          },
          // {
          //   params: { tab: 'terms-and-policies', subtab: 'insurance-policy' },
          //   textKey: 'insurance-policy',
          // },
          {
            params: { tab: 'terms-and-policies', subtab: 'cancellation-policy' },
            textKey: 'cancellation-policy',
          },
          {
            params: { tab: 'terms-and-policies', subtab: 'payments-terms' },
            textKey: 'payments-terms',
          },
        ],
      },
    ],
    isHorizontal: true,
  },

  {
    titleKey: 'traveller-questions',
    subsections: [
      {
        icon: IconSearchStrong,
        subtitleKey: 'searching-and-booking',
        links: [
          {
            params: { tab: 'searching-and-booking', subtab: 'what-can-i-find' },
            textKey: 'what-can-i-find',
          },
          {
            params: { tab: 'searching-and-booking', subtab: 'who-is-the-provider' },
            textKey: 'who-is-the-provider',
          },
          {
            params: { tab: 'searching-and-booking', subtab: 'search-tips' },
            textKey: 'search-tips',
          },
          {
            params: { tab: 'searching-and-booking', subtab: 'browse-the-listing' },
            textKey: 'browse-the-listing',
          },
          {
            params: { tab: 'searching-and-booking', subtab: 'booking-an-activity' },
            textKey: 'booking-an-activity',
          },
        ],
      },
      {
        icon: IconEvent,
        subtitleKey: 'your-bookings',
        links: [
          {
            params: { tab: 'your-bookings', subtab: 'booking-status' },
            textKey: 'booking-status',
          },
          {
            params: { tab: 'your-bookings', subtab: 'changes-and-cancellations' },
            textKey: 'changes-and-cancellations',
          },
          {
            params: { tab: 'your-bookings', subtab: 'preparing-for-an-activity' },
            textKey: 'preparing-for-an-activity',
          },
          {
            params: { tab: 'your-bookings', subtab: 'meeting-with-the-provider' },
            textKey: 'meeting-with-the-provider',
          },
          {
            params: { tab: 'your-bookings', subtab: 'issue-with-a-booking' },
            textKey: 'issue-with-a-booking',
          },
        ],
      },
      {
        icon: IconCreditCard,
        subtitleKey: 'payment-pricing-and-refunds',
        links: [
          {
            params: { tab: 'payment-pricing-and-refunds', subtab: 'paying-for-a-booking' },
            textKey: 'paying-for-a-booking',
          },
          { params: { tab: 'payment-pricing-and-refunds', subtab: 'refunds' }, textKey: 'refunds' },
          {
            params: { tab: 'payment-pricing-and-refunds', subtab: 'pricing-and-fees' },
            textKey: 'pricing-and-fees',
          },
          {
            params: { tab: 'payment-pricing-and-refunds', subtab: 'discount-codes' },
            textKey: 'discount-codes',
          },
          {
            params: { tab: 'payment-pricing-and-refunds', subtab: 'invoices-and-recipts' },
            textKey: 'invoices-and-recipts',
          },
        ],
      },
    ],
  },

  {
    titleKey: 'provider-questions',
    subsections: [
      {
        icon: IconLocalOffer,
        subtitleKey: 'about-offering-a-service',
        links: [
          {
            params: { tab: 'about-offering-a-service', subtab: 'what-can-i-post' },
            textKey: 'what-can-i-post',
          },
          {
            params: { tab: 'about-offering-a-service', subtab: 'provider-types' },
            textKey: 'provider-types',
          },
          {
            params: { tab: 'about-offering-a-service', subtab: 'requirements' },
            textKey: 'requirements',
          },
          {
            params: { tab: 'about-offering-a-service', subtab: 'certifications' },
            textKey: 'certifications',
          },
          {
            params: { tab: 'about-offering-a-service', subtab: 'the-listing' },
            textKey: 'the-listing',
          },
        ],
      },
      {
        icon: IconDescription,
        subtitleKey: 'managing-your-listings',
        links: [
          {
            params: { tab: 'managing-your-listings', subtab: 'create-and-edit-your-listing' },
            textKey: 'create-and-edit-your-listing',
          },
          {
            params: { tab: 'managing-your-listings', subtab: 'publish-your-listing' },
            textKey: 'publish-your-listing',
          },
          {
            params: { tab: 'managing-your-listings', subtab: 'calendar-and-reservations' },
            textKey: 'calendar-and-reservations',
          },
          {
            params: { tab: 'managing-your-listings', subtab: 'pricing-and-fees-2' },
            textKey: 'pricing-and-fees-2',
          },
          {
            params: { tab: 'managing-your-listings', subtab: 'marketing-and-promotion' },
            textKey: 'marketing-and-promotion',
          },
        ],
      },
      {
        icon: IconQuestionAnswer,
        subtitleKey: 'your-reservations',
        links: [
          {
            params: { tab: 'your-reservations', subtab: 'reservation-status' },
            textKey: 'reservation-status',
          },
          {
            params: { tab: 'your-reservations', subtab: 'cancellations' },
            textKey: 'cancellations',
          },
          {
            params: { tab: 'your-reservations', subtab: 'communicating-with-travelers' },
            textKey: 'communicating-with-travelers',
          },
          {
            params: { tab: 'your-reservations', subtab: 'issue-with-a-reservation' },
            textKey: 'issue-with-a-reservation',
          },
        ],
      },
      {
        icon: IconPaid,
        subtitleKey: 'payouts-and-taxes',
        links: [
          { params: { tab: 'payouts-and-taxes', subtab: 'payout' }, textKey: 'payout' },
          { params: { tab: 'payouts-and-taxes', subtab: 'taxes' }, textKey: 'taxes' },
        ],
      },
    ],
  },
];
